export default "__VITE_ASSET__36a2fe2a__"